import clsx from "clsx";
import { NavLink } from "react-router-dom";
import { railModules } from "./navConfig";

export function NavRail() {
  const modules = railModules();

  return (
    <nav className="flex w-14 flex-col gap-1 border-r border-border bg-panel py-2">
      {modules.map((m) => (
        <NavLink
          key={m.path}
          to={m.path}
          end={m.path === "/"}
          title={m.label}
          className={({ isActive }) =>
            clsx(
              "mx-auto flex h-12 w-12 flex-col items-center justify-center rounded-none border text-lg leading-none transition",
              isActive
                ? "border-[var(--color-info,#0ea5e9)] bg-[var(--bg-secondary,#1e1e1e)] text-[var(--fg-primary,#e5e5e5)]"
                : "border-transparent text-muted hover:border-border hover:text-[var(--fg-secondary,#d0d0d0)]",
            )
          }
        >
          <span>{m.icon}</span>
        </NavLink>
      ))}
    </nav>
  );
}
